import { render, staticRenderFns } from "./LessonPanelTeacherComments.vue?vue&type=template&id=6a2da642&"
import script from "./LessonPanelTeacherComments.vue?vue&type=script&lang=ts&"
export * from "./LessonPanelTeacherComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports